import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { APP_URL_CHECKOUT, APP_URL_PAYMENT, STORAGE_KEY_USER_VISITED_PAYMENTS } from '../const';
import storageService from '../service/StorageService';
import { tryToCreateOfferRedirect } from '../store/slices/modalsSlice';

// HORO-10478: purchases moved to /checkout, but the legacy /payment page is
// still routable (and still marks a visit), so the win-back offer has to watch
// both. Without /checkout here the offer would silently stop firing, since
// nothing sends customers to /payment any more.
const PAYMENT_PATHNAMES = [`/${APP_URL_CHECKOUT}`, `/${APP_URL_PAYMENT}`];

const useCatchRedirect = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const pathname = location.pathname;
        if (PAYMENT_PATHNAMES.includes(pathname)) {
            storageService.add(STORAGE_KEY_USER_VISITED_PAYMENTS, true);
            return;
        }

        const isUserVisitedPayments = storageService.get(STORAGE_KEY_USER_VISITED_PAYMENTS);
        if (isUserVisitedPayments) {
            storageService.delete(STORAGE_KEY_USER_VISITED_PAYMENTS);
            dispatch(tryToCreateOfferRedirect());
        }
    }, [location.pathname]);
};

export default useCatchRedirect;
